import axios from "axios";
import { SUPPLIER_LIST_FAIL, SUPPLIER_LIST_REQUEST, SUPPLIER_LIST_SUCCESS } from "../constats/supplier.constant";
import { endpointApi } from "../../utils";
import { logout } from "./auth.action";

export const getSuppliers = (location=null, navigate=null) => async (dispatch) => {
    try {
        const jwt_access = localStorage.getItem('jwt_access');
        dispatch({
            type: SUPPLIER_LIST_REQUEST
        });
        const { data } = await axios.get(`${ endpointApi }suppliers${ location ? location.search : "" }`, {
            headers: {
                'Authorization': `Bearer ${ jwt_access }`
            }
        });
        dispatch({
            type: SUPPLIER_LIST_SUCCESS,
            payload: data
        });
    } catch (err) {
        if(err.response.status === 401){
            dispatch({
                type: SUPPLIER_LIST_FAIL,
                payload: null
            });
            const url = location ? location.pathname + location.search : null;
            dispatch(logout(url, navigate));
        }else{
            dispatch({
                type: SUPPLIER_LIST_FAIL,
                payload: err.response && err.response.data.message ? err.response.data.message : err.message
            });
        }
    }
}